export type CookieCategory = "necessary" | "analytics" | "functional" | "marketing";

export interface ConsentState {
  necessary: boolean;
  analytics: boolean;
  functional: boolean;
  marketing: boolean;
  timestamp: string;
  version: string;
}

export type ConsentAction = "accept_all" | "reject_non_essential" | "customize";

export interface ConsentLogPayload {
  categories: Record<CookieCategory, boolean>;
  consent_version: string;
  source_app: string;
  action: ConsentAction;
  user_agent: string;
}

export const CONSENT_COOKIE_NAME = "vs_consent";
export const CONSENT_VERSION = "1.0";
export const CONSENT_EVENT = "vs:consent-updated";
export const CONSENT_MAX_AGE_DAYS = 365;
